import React from "react";
import { Navigate } from "react-router-dom";

// // Pages Component
import Chat from "../pages/Chat/Chat";

// Dashboard
import Dashboard from "../pages/Dashboard/index";
import RestaurantDashboard from "../pages/Restaurant Portal/RestaurantDashboardPage.jsx";
import SettlementDashboard from "../pages/Restaurant Portal/Settlements/SettlementDashboardPage.jsx";
import RestaurantPastSettlementsPage from "../pages/Restaurant Portal/Settlements/RestaurantPastSettlementsPage.jsx";
import RestaurantWeeklySettlementInvoicePage from "../pages/Restaurant Portal/Settlements/WeeklySettlementInvoicePage.jsx";
import MarketInsightPage from "../pages/Restaurant Portal/MarketInsight/MarketInsightPage.jsx";
import MarketInsightDetailPage from "../pages/Restaurant Portal/MarketInsight/MarketInsightDetailPage.jsx";
import CustomersPage from "../pages/Restaurant Portal/Customers/CustomersPage.jsx";
import CustomerDetailPage from "../pages/Restaurant Portal/Customers/CustomerDetailPage.jsx";
import StaffCreatePage from "../pages/Restaurant Portal/Staff/StaffCreatePage.jsx";
import RestaurantStaffPage from "../pages/Restaurant Portal/Staff/RestaurantStaffPage.jsx";
import RestaurantProfilePage from "../pages/Restaurant Portal/RestaurantProfile/RestaurantProfilePage.jsx";
import RestaurantActivityLogsPage from "../pages/Restaurant Portal/RestaurantProfile/RestaurantActivityLogsPage.jsx";
import RestaurantSettingsPage from "../pages/Restaurant Portal/RestaurantSettings/RestaurantSettingsPage.jsx";
import RestaurantNotificationsPage from "../pages/Restaurant Portal/Notifications/RestaurantNotificationsPage.jsx";

// Admin Portal
import AdminDashboardPage from "../pages/Admin Portal/AdminDashboardPage.jsx";
import AdminSettlementDashboardPage from "../pages/Admin Portal/Settlements/AdminSettlementDashboardPage.jsx";
import AdminPartnerSettlementsPage from "../pages/Admin Portal/Settlements/AdminPartnerSettlementsPage.jsx";
import AdminMarketInsightPage from "../pages/Admin Portal/MarketInsight/AdminMarketInsightPage.jsx";
import AdminStaffCreatePage from "../pages/Admin Portal/Staff/AdminStaffCreatePage.jsx";
import AdminStaffPage from "../pages/Admin Portal/Staff/AdminStaffPage.jsx";
import AdminUsersCreatePage from "../pages/Admin Portal/Users/AdminUsersCreatePage.jsx";
import AdminUsersPage from "../pages/Admin Portal/Users/AdminUsersPage.jsx";
import AdminDeletedUsersPage from "../pages/Admin Portal/Users/AdminDeletedUsersPage.jsx";
import AdminUserDetailPage from "../pages/Admin Portal/Users/AdminUserDetailPage.jsx";
import AdminProfilePage from "../pages/Admin Portal/AdminProfile/AdminProfilePage.jsx";
import AdminActivityLogsPage from "../pages/Admin Portal/AdminProfile/AdminActivityLogsPage.jsx";
import AdminSettingsPage from "../pages/Admin Portal/AdminSettings/AdminSettingsPage.jsx";
import AdminNotificationsPage from "../pages/Admin Portal/Notifications/AdminNotificationsPage.jsx";
import AdminPointsLedgerPage from "../pages/Admin Portal/Points Ledger/AdminPointsLedgerPage.jsx";
import AdminPointsRedemptionTiersPage from "../pages/Admin Portal/Points Redemption Tiers/AdminPointsRedemptionTiersPage.jsx";
import AdminPointsRedemptionTierCreatePage from "../pages/Admin Portal/Points Redemption Tiers/AdminPointsRedemptionTierCreatePage.jsx";
import AdminFAQsPage from "../pages/Admin Portal/FAQs/AdminFAQsPage.jsx";
import AdminFAQCreatePage from "../pages/Admin Portal/FAQs/AdminFAQCreatePage.jsx";
import AdminCustomerFinancialAccountsPage from "../pages/Admin Portal/CustomerFinancialAccounts/AdminCustomerFinancialAccountsPage.jsx";
import AdminRestaurantConnectAccountsPage from "../pages/Admin Portal/RestaurantConnectAccounts/AdminRestaurantConnectAccountsPage.jsx";
import AdminGamesPage from "../pages/Admin Portal/Games/AdminGamesPage.jsx";
import AdminGameCreatePage from "../pages/Admin Portal/Games/AdminGameCreatePage.jsx";
import AdminNetworkLeakageDashboardPage from "../pages/Admin Portal/Network Leakage/NetworkLeakageDashboardPage.jsx";
import AdminPlatformFeesDashboardPage from "../pages/Admin Portal/Platform Fees/PlatformFeesDashboardPage.jsx";
import AdminRestaurantsPage from "../pages/Admin Portal/Restaurants/AdminRestaurantsPage.jsx";
import AdminNonSetupRestaurantsPage from "../pages/Admin Portal/Restaurants/AdminNonSetupRestaurantsPage.jsx";
import AdminRestaurantsCreatePage from "../pages/Admin Portal/Restaurants/AdminRestaurantsCreatePage.jsx";
import AdminRestaurantsEditPage from "../pages/Admin Portal/Restaurants/AdminRestaurantsEditPage.jsx";
import AdminRestaurantDetailPage from "../pages/Admin Portal/Restaurants/AdminRestaurantDetailPage.jsx";
import WeeklySettlementInvoicePage from "../pages/Admin Portal/Settlements/WeeklySettlementInvoicePage.jsx";

// Redemption
import RedemptionsPage from "../pages/Restaurant Portal/Redemption/RedemptionsPage.jsx";

// Wallet
import WalletPage from "../pages/Wallet/WalletPage";
import RestaurantWalletPage from "../pages/Restaurant Portal/Wallet/RestaurantWalletPage";
import RestaurantTransactionHistoryPage from "../pages/Restaurant Portal/Wallet/RestaurantTransactionHistoryPage";
import PointsActivityPage from "../pages/Wallet/PointsActivityPage";

// Vouchers
import VouchersPage from "../pages/Vouchers/VouchersPage";

// Notifications
// eslint-disable-next-line no-unused-vars
import NotificationsPage from "../pages/Notifications/NotificationsPage";

// Games
import GamesPage from "../pages/Games/GamesPage";

// Profile
import ProfilePage from "../pages/UserProfile/ProfilePage";

// Settings
import SettingsPage from "../pages/Settings/SettingsPage";

// Referrals
import ReferralsPage from "../pages/Referrals/ReferralsPage";

// Support
import SupportPage from "../pages/Support/SupportPage";
import TermsOfService from "../pages/Support/TermsOfService";
import PrivacyPolicy from "../pages/Support/PrivacyPolicy";

// Restaurants
import RestaurantsPage from "../pages/Restaurants/RestaurantsPage";
// Pages Calendar
import Calendar from "../pages/Calendar/index";

// //Ecommerce Pages
import EcommerceProducts from "../pages/Ecommerce/EcommerceProducts/index";
import EcommerceProductDetail from "../pages/Ecommerce/EcommerceProducts/EcommerceProductDetail";
import EcommerceOrders from "../pages/Ecommerce/EcommerceOrders/index";
import EcommerceCustomers from "../pages/Ecommerce/EcommerceCustomers/index";
import EcommerceCart from "../pages/Ecommerce/EcommerceCart";
import EcommerceCheckout from "../pages/Ecommerce/EcommerceCheckout";
import EcommerceShops from "../pages/Ecommerce/EcommerceShops/index";
import EcommerceAddProduct from "../pages/Ecommerce/EcommerceAddProduct";

//Email
import EmailInbox from "../pages/Email/email-inbox";
import EmailRead from "../pages/Email/email-read";
import EmailBasicTemplte from "../pages/Email/email-basic-templte";
import EmailAlertTemplte from "../pages/Email/email-template-alert";
import EmailTemplateBilling from "../pages/Email/email-template-billing";

//Invoices
import InvoicesList from "../pages/Invoices/invoices-list";
import InvoiceDetail from "../pages/Invoices/invoices-detail";

//Contacts
import ContactsGrid from "../pages/Contacts/contacts-grid";
import ContactsList from "../pages/Contacts/ContactList/contacts-list";
import ContactsProfile from "../pages/Contacts/ContactsProfile/contacts-profile";

//Pages
import PagesStarter from "../pages/Utility/pages-starter";
import PagesMaintenance from "../pages/Utility/pages-maintenance";
import PagesComingsoon from "../pages/Utility/pages-comingsoon";
import PagesTimeline from "../pages/Utility/pages-timeline";
import PagesFaqs from "../pages/Utility/pages-faqs";
import PagesPricing from "../pages/Utility/pages-pricing";
import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";

//Ui
import UiAlert from "../pages/Ui/UiAlert";
import UiButtons from "../pages/Ui/UiButtons";
import UiCards from "../pages/Ui/UiCards";
import UiCarousel from "../pages/Ui/UiCarousel";
import UiColors from "../pages/Ui/UiColors";
import UiDropdown from "../pages/Ui/UiDropdown";
import UiGeneral from "../pages/Ui/UiGeneral";
import UiGrid from "../pages/Ui/UiGrid";
import UiImages from "../pages/Ui/UiImages";
import UiLightbox from "../pages/Ui/UiLightbox";
import UiModal from "../pages/Ui/UiModal";
import UiOffcanvas from "../pages/Ui/UiOffcanvas";
import UiProgressbar from "../pages/Ui/UiProgressbar";
import UiPlaceholders from "../pages/Ui/UiPlaceholders";
import UiTabsAccordions from "../pages/Ui/UiTabsAccordions";
import UiTypography from "../pages/Ui/UiTypography";
import UiToasts from "../pages/Ui/UiToasts";
import UiVideo from "../pages/Ui/UiVideo";
import UiSessionTimeout from "../pages/Ui/UiSessionTimeout";
import UiRating from "../pages/Ui/UiRating";
import UiRangeSlider from "../pages/Ui/UiRangeSlider";
import UiNotifications from "../pages/Ui/ui-notifications";
import UiImageCropper from "../pages/Ui/ui-image-cropper";

// Forms
import BasicElements from "../pages/Forms/BasicElements";
import FormLayouts from "../pages/Forms/FormLayouts";
import FormAdvanced from "../pages/Forms/FormAdvanced";
import FormEditors from "../pages/Forms/FormEditors";
import FormValidations from "../pages/Forms/FormValidations";
import FormMask from "../pages/Forms/FormMask";
import FormRepeater from "../pages/Forms/FormRepeater";
import FormUpload from "../pages/Forms/FormUpload";
import FormWizard from "../pages/Forms/FormWizard";

//Tables
import BasicTables from "../pages/Tables/BasicTables";
import DatatableTables from "../pages/Tables/DatatableTables";
import ResponsiveTables from "../pages/Tables/ResponsiveTables";

// Charts
import ChartApex from "../pages/Charts/Apexcharts";
import ChartjsChart from "../pages/Charts/ChartjsChart";
import EChart from "../pages/Charts/EChart";
import SparklineChart from "../pages/Charts/SparklineChart";
import ChartsKnob from "../pages/Charts/charts-knob";

//Icons

import IconUnicons from "../pages/Icons/IconUnicons";
import IconBoxicons from "../pages/Icons/IconBoxicons";
import IconDripicons from "../pages/Icons/IconDripicons";
import IconMaterialdesign from "../pages/Icons/IconMaterialdesign";
import IconFontawesome from "../pages/Icons/IconFontawesome";

// Maps
import MapsGoogle from "../pages/Maps/MapsGoogle";
import MapsVector from "../pages/Maps/MapsVector";

// File Manager
import FileManager from "../pages/FileManager";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPassword from "../pages/Authentication/ForgetPassword";
import ResetPassword from "../pages/Authentication/ResetPassword";
import RestaurantTerminalLogin from "../pages/Authentication/RestaurantTerminalLogin.js";
import RestaurantRedeemVoucher from "../pages/Authentication/RestaurantRedeemVoucher.js";

//  // Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login";
import Register1 from "../pages/AuthenticationInner/Register";
import Recoverpw from "../pages/AuthenticationInner/Recoverpw";
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";

// Profile
import UserProfile from "../pages/Authentication/user-profile";
import UiUtilities from "../pages/Ui/ui-utilities";
import EmailVerify from "../pages/Authentication/EmailVerify";

// Customer Routes - for regular users
const customerRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/wallet", component: <WalletPage /> },
  { path: "/points-activity", component: <PointsActivityPage /> },
  { path: "/vouchers", component: <VouchersPage /> },
  { path: "/notifications", component: <NotificationsPage /> },
  { path: "/restaurants", component: <RestaurantsPage /> },
  { path: "/profile", component: <ProfilePage /> },
  { path: "/settings", component: <SettingsPage /> },
  { path: "/referrals", component: <ReferralsPage /> },
  { path: "/support", component: <SupportPage /> },
  { path: "/terms-of-service", component: <TermsOfService /> },
  { path: "/privacy-policy", component: <PrivacyPolicy /> },
  { path: "/games", component: <GamesPage /> },

  { path: "/calendar", component: <Calendar /> },
  //chat
  { path: "/chat", component: <Chat /> },

  //Ecommerce
  { path: "/ecommerce-products", component: <EcommerceProducts /> },
  { path: "/ecommerce-product-detail", component: <EcommerceProductDetail /> },
  {
    path: "/ecommerce-products-detail/:id",
    component: <EcommerceProductDetail />,
  },
  { path: "/ecommerce-orders", component: <EcommerceOrders /> },
  { path: "/ecommerce-customers", component: <EcommerceCustomers /> },
  { path: "/ecommerce-cart", component: <EcommerceCart /> },
  { path: "/ecommerce-checkout", component: <EcommerceCheckout /> },
  { path: "/ecommerce-shops", component: <EcommerceShops /> },
  { path: "/ecommerce-add-product", component: <EcommerceAddProduct /> },

  //Email
  { path: "/email-inbox", component: <EmailInbox /> },
  { path: "/email-read", component: <EmailRead /> },
  { path: "/email-template-basic", component: <EmailBasicTemplte /> },
  { path: "/email-template-alert", component: <EmailAlertTemplte /> },
  { path: "/email-template-billing", component: <EmailTemplateBilling /> },

  //Invoices
  { path: "/invoices-list", component: <InvoicesList /> },
  { path: "/invoices-detail", component: <InvoiceDetail /> },
  { path: "/invoices-detail/:id", component: <InvoiceDetail /> },

  // Contacts
  { path: "/contacts-grid", component: <ContactsGrid /> },
  { path: "/contacts-list", component: <ContactsList /> },
  { path: "/contacts-profile", component: <ContactsProfile /> },

  //Utility
  { path: "/pages-starter", component: <PagesStarter /> },
  { path: "/pages-timeline", component: <PagesTimeline /> },
  { path: "/pages-faqs", component: <PagesFaqs /> },
  { path: "/pages-pricing", component: <PagesPricing /> },

  // Ui
  { path: "/ui-alerts", component: <UiAlert /> },
  { path: "/ui-buttons", component: <UiButtons /> },
  { path: "/ui-cards", component: <UiCards /> },
  { path: "/ui-carousel", component: <UiCarousel /> },
  { path: "/ui-colors", component: <UiColors /> },
  { path: "/ui-dropdowns", component: <UiDropdown /> },
  { path: "/ui-general", component: <UiGeneral /> },
  { path: "/ui-grid", component: <UiGrid /> },
  { path: "/ui-images", component: <UiImages /> },
  { path: "/ui-lightbox", component: <UiLightbox /> },
  { path: "/ui-modals", component: <UiModal /> },
  { path: "/ui-offcanvas", component: <UiOffcanvas /> },
  { path: "/ui-progressbars", component: <UiProgressbar /> },
  { path: "/ui-placeholders", component: <UiPlaceholders /> },
  { path: "/ui-tabs-accordions", component: <UiTabsAccordions /> },
  { path: "/ui-typography", component: <UiTypography /> },
  { path: "/ui-toasts", component: <UiToasts /> },
  { path: "/ui-video", component: <UiVideo /> },
  { path: "/ui-session-timeout", component: <UiSessionTimeout /> },
  { path: "/ui-rating", component: <UiRating /> },
  { path: "/ui-rangeslider", component: <UiRangeSlider /> },
  { path: "/ui-notifications", component: <UiNotifications /> },
  { path: "/ui-image-cropper", component: <UiImageCropper /> },
  { path: "/ui-utilities", component: <UiUtilities /> },

  // Forms
  { path: "/basic-elements", component: <BasicElements /> },
  { path: "/form-layouts", component: <FormLayouts /> },
  { path: "/form-advanced", component: <FormAdvanced /> },
  { path: "/form-editors", component: <FormEditors /> },
  { path: "/form-mask", component: <FormMask /> },
  { path: "/form-repeater", component: <FormRepeater /> },
  { path: "/form-uploads", component: <FormUpload /> },
  { path: "/form-wizard", component: <FormWizard /> },
  { path: "/form-validation", component: <FormValidations /> },

  // Tables
  { path: "/tables-basic", component: <BasicTables /> },
  { path: "/tables-datatable", component: <DatatableTables /> },
  { path: "/tables-responsive", component: <ResponsiveTables /> },

  //Charts
  { path: "/apex-charts", component: <ChartApex /> },
  { path: "/chartjs-charts", component: <ChartjsChart /> },
  { path: "/e-charts", component: <EChart /> },
  { path: "/sparkline-charts", component: <SparklineChart /> },
  { path: "/charts-knob", component: <ChartsKnob /> },

  // Icons
  { path: "/icons-unicons", component: <IconUnicons /> },
  { path: "/icons-boxicons", component: <IconBoxicons /> },
  { path: "/icons-dripicons", component: <IconDripicons /> },
  { path: "/icons-materialdesign", component: <IconMaterialdesign /> },
  { path: "/icons-fontawesome", component: <IconFontawesome /> },

  // Maps
  { path: "/maps-google", component: <MapsGoogle /> },
  { path: "/maps-vector", component: <MapsVector /> },

  // File Manager
  { path: "/file-manager", component: <FileManager /> },

  // //profile
  { path: "/profile", component: <UserProfile /> },
];

// Restaurant Routes - for restaurant users
const restaurantRoutes = [
  { path: "/restaurant/dashboard", component: <RestaurantDashboard /> },
  { path: "/restaurant/redemptions", component: <RedemptionsPage /> },
  { path: "/restaurant/settlements", component: <SettlementDashboard /> },
  {
    path: "/restaurant/settlements/invoices/:invoiceId",
    component: <RestaurantWeeklySettlementInvoicePage />,
  },
  {
    path: "/restaurant/settlements/past",
    component: <RestaurantPastSettlementsPage />,
  },
  { path: "/restaurant/market-insights", component: <MarketInsightPage /> },
  {
    path: "/restaurant/market-insight/detail",
    component: <MarketInsightDetailPage />,
  },
  { path: "/restaurant/customers", component: <CustomersPage /> },
  {
    path: "/restaurant/customers/detail",
    component: <CustomerDetailPage />,
  },
  { path: "/restaurant/staff", component: <RestaurantStaffPage /> },
  {
    path: "/restaurant/staff/create",
    component: <StaffCreatePage mode="create" />,
  },
  {
    path: "/restaurant/staff/:staffId/edit",
    component: <StaffCreatePage mode="edit" />,
  },
  { path: "/restaurants", component: <RestaurantsPage /> },
  { path: "/restaurant/wallet", component: <RestaurantWalletPage /> },
  {
    path: "/restaurant/transactions",
    component: <RestaurantTransactionHistoryPage />,
  },
  { path: "/restaurant/profile", component: <RestaurantProfilePage /> },
  {
    path: "/restaurant/profile/activity-logs",
    component: <RestaurantActivityLogsPage />,
  },
  { path: "/restaurant/settings", component: <RestaurantSettingsPage /> },
  {
    path: "/restaurant/notifications",
    component: <RestaurantNotificationsPage />,
  },
  { path: "/restaurant/terms-of-service", component: <TermsOfService /> },
  { path: "/restaurant/privacy-policy", component: <PrivacyPolicy /> },
  // TODO: Add more restaurant-specific routes here
  // { path: "/restaurant/platform-fees", component: <RestaurantPlatformFees /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/restaurant",
    exact: true,
    component: <Navigate to="/restaurant/dashboard" />,
  },
];

// Admin Routes - for admin users
const adminRoutes = [
  { path: "/admin/dashboard", component: <AdminDashboardPage /> },
  { path: "/admin/points-ledger", component: <AdminPointsLedgerPage /> },
  {
    path: "/admin/points-redemption-tiers",
    component: <AdminPointsRedemptionTiersPage />,
  },
  {
    path: "/admin/points-redemption-tiers/create",
    component: <AdminPointsRedemptionTierCreatePage mode="create" />,
  },
  {
    path: "/admin/points-redemption-tiers/:tierId/edit",
    component: <AdminPointsRedemptionTierCreatePage mode="edit" />,
  },
  { path: "/admin/settlements", component: <AdminSettlementDashboardPage /> },
  {
    path: "/admin/settlements/partners",
    component: <AdminPartnerSettlementsPage />,
  },
  {
    path: "/admin/settlements/invoices/:invoiceId",
    component: <WeeklySettlementInvoicePage />,
  },
  {
    path: "/admin/network-leakage",
    component: <AdminNetworkLeakageDashboardPage />,
  },
  {
    path: "/admin/platform-fees",
    component: <AdminPlatformFeesDashboardPage />,
  },
  { path: "/admin/market-insights", component: <AdminMarketInsightPage /> },
  {
    path: "/admin/customer-financial-accounts",
    component: <AdminCustomerFinancialAccountsPage />,
  },
  {
    path: "/admin/restaurant-connect-accounts",
    component: <AdminRestaurantConnectAccountsPage />,
  },
  { path: "/admin/staff", component: <AdminStaffPage /> },
  {
    path: "/admin/staff/create",
    component: <AdminStaffCreatePage mode="create" />,
  },
  {
    path: "/admin/staff/:staffId/edit",
    component: <AdminStaffCreatePage mode="edit" />,
  },
  { path: "/admin/users", component: <AdminUsersPage /> },
  { path: "/admin/users/deleted", component: <AdminDeletedUsersPage /> },
  {
    path: "/admin/users/create",
    component: <AdminUsersCreatePage mode="create" />,
  },
  {
    path: "/admin/users/:userId/edit",
    component: <AdminUsersCreatePage mode="edit" />,
  },
  {
    path: "/admin/users/:userId/view",
    component: <AdminUserDetailPage />,
  },
  { path: "/admin/restaurants", component: <AdminRestaurantsPage /> },
  {
    path: "/admin/restaurants/non-setup",
    component: <AdminNonSetupRestaurantsPage />,
  },
  {
    path: "/admin/restaurants/create",
    component: <AdminRestaurantsCreatePage mode="create" />,
  },
  {
    path: "/admin/restaurants/:restaurantId/edit",
    component: <AdminRestaurantsEditPage />,
  },
  {
    path: "/admin/restaurants/:restaurantId/view",
    component: <AdminRestaurantDetailPage />,
  },
  { path: "/admin/profile", component: <AdminProfilePage /> },
  {
    path: "/admin/profile/activity-logs",
    component: <AdminActivityLogsPage />,
  },
  { path: "/admin/settings", component: <AdminSettingsPage /> },
  {
    path: "/admin/notifications",
    component: <AdminNotificationsPage />,
  },
  { path: "/admin/faqs", component: <AdminFAQsPage /> },
  {
    path: "/admin/faqs/create",
    component: <AdminFAQCreatePage mode="create" />,
  },
  {
    path: "/admin/faqs/:faqId/edit",
    component: <AdminFAQCreatePage mode="edit" />,
  },
  { path: "/admin/games", component: <AdminGamesPage /> },
  {
    path: "/admin/games/create",
    component: <AdminGameCreatePage mode="create" />,
  },
  {
    path: "/admin/games/:gameSlug/edit",
    component: <AdminGameCreatePage mode="edit" />,
  },
  { path: "/admin/terms-of-service", component: <TermsOfService /> },
  { path: "/admin/privacy-policy", component: <PrivacyPolicy /> },
  // TODO: Add more admin-specific routes here
  // { path: "/admin/restaurants", component: <AdminRestaurants /> },
  // { path: "/admin/platform-fees", component: <AdminPlatformFees /> },
  // { path: "/admin/points-ledger", component: <AdminPointsLedger /> },
  // { path: "/admin/activity-logs", component: <AdminActivityLogs /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/admin",
    exact: true,
    component: <Navigate to="/admin/dashboard" />,
  },
];

// Legacy userRoutes for backward compatibility (will be removed after migration)
const userRoutes = customerRoutes;

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  {
    path: "/restaurant/terminal-login",
    component: <RestaurantTerminalLogin />,
  },
  {
    path: "/restaurant/redeem-voucher",
    component: <RestaurantRedeemVoucher />,
  },
  { path: "/email-verify", component: <EmailVerify /> },
  { path: "/forgot-password", component: <ForgetPassword /> },
  {
    path: "/restaurant/forgot-password",
    component: <ForgetPassword />,
  },
  {
    path: "/admin/forgot-password",
    component: <ForgetPassword />,
  },
  { path: "/reset-password/:token", component: <ResetPassword /> },
  {
    path: "/restaurant/reset-password/:token",
    component: <ResetPassword />,
  },
  {
    path: "/admin/reset-password/:token",
    component: <ResetPassword />,
  },
  { path: "/register", component: <Register /> },

  { path: "/pages-maintenance", component: <PagesMaintenance /> },
  { path: "/pages-comingsoon", component: <PagesComingsoon /> },
  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },

  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
];

export {
  customerRoutes,
  restaurantRoutes,
  adminRoutes,
  userRoutes,
  authRoutes,
};
